<template>
  <v-container fluid>
      <v-layout row wrap>
        <v-flex sm6 xs12 class="pa-3">
             <v-data-table
                :headers="headers"
                :items="items"
                hide-actions
                class="elevation-1"
            >
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.anios }}</td>
                    <td>{{ formatPrice(props.item.acumulado) }}</td>
                </template>
            </v-data-table>
        </v-flex>        
        <v-flex sm6 xs12 class="pa-3">
            <v-form>
                <v-text-field
                    label="Monto inicial"
                    v-model="entrada.inicial"
                    type="number"
                    ></v-text-field>
                <v-text-field
                    label="Cuota Anual"
                    v-model="entrada.cuota_anual"
                    type="number"
                    ></v-text-field>
                <v-text-field
                    label="Interes"
                    v-model="entrada.interes"
                    ></v-text-field>
            </v-form>
        </v-flex>
      </v-layout>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      entrada: {
        inicial: 0,
        cuota_anual: 3600000,
        interes: 3.6
      },
      headers: [
        { text: "Años", value: "anios" },
        { text: "Acumulado", value: "acumulado" }
      ],
      items: []
    };
  },
  watch: {
    entrada: {
      handler: function(val) {
        this.calcular();
      },
      deep: true
    }
  },
  mounted(){
      this.calcular();
      this.$emit('setTitulo',"Proyección de Ahorros")
  },
  methods: {
    calcular() {
      const vm = this;
      const val = vm.entrada;
      let total = parseInt(val.inicial);
      const interes = parseFloat(val.interes);
      const cuota = parseInt(val.cuota_anual);
      const base = 1 + interes / 100;
      vm.items = [];
      for (let index = 1; index <= 40; index++) {
        let periodo = total + cuota;

        total = periodo * base;

        if (index % 10 == 0) {
          vm.items.push({
            anios: index,
            acumulado: parseInt(total)
          });
        }
      }
    },
    formatPrice(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
  /*computed:{
      items : function(){
          const data = [];
          let refff = this.entrada;
          for (let index = 0; index < 40; index++) {
            console.log(index);
          }
          return data;
      }
  }*/
};
</script>




// WEBPACK FOOTER //
// src/components/Ahorro.vue